module.exports = __webpack_public_path__ + "img/upgrade-img-3.e64fc1a0.png";